/** Rarity key для фильтра и отображения (выводится из step/tier) */
export type RarityKey = 'common' | 'rare' | 'epic' | 'legendary';

/**
 * Выводит rarity из step NFT (синхрон с backend Nft::TIER_RANGES).
 * Tier 4 = common, 3 = rare, 2 = epic, 1 = legendary.
 */
export function stepToRarity(step?: number | null, tier?: number | null): RarityKey {
  const t = tier ?? (step != null ? stepToTier(step) : null);
  if (t == null) return 'common';
  switch (t) {
    case 1: return 'legendary';
    case 2: return 'epic';
    case 3: return 'rare';
    default: return 'common';
  }
}

/** Tier из step (1-6->4, 7-9->3, 10-12->2, 13-15->1) */
function stepToTier(step: number): number | null {
  if (step >= 1 && step <= 6) return 4;
  if (step >= 7 && step <= 9) return 3;
  if (step >= 10 && step <= 12) return 2;
  if (step >= 13 && step <= 15) return 1;
  return null;
}
